import React, { Component } from 'react';
import PropTypes from 'prop-types';

import QuestionBuilderComponent from './QuestionBuilder';

class QuestionBuilder extends Component {
	static propTypes = {
		type: PropTypes.string,
		paragraphText1: PropTypes.string,
		TextHeadingTwoText: PropTypes.string,
		paragraphText2: PropTypes.string
	};
	state = { actions: [ ...this.props.data ], placeholder: 'Enter user message' };
	toggleButton = (func) => {
		document.getElementById('add-trigger').classList[func]('btn--disabled');
	};
	addTrigger = (e) => {
		e.preventDefault();
		let { actions } = this.state;
		this.setState({ actions: [...actions, this.state.placeholder] }, () => this.toggleButton('add'));
		// actions.push(this.state.placeholder);
	};
	removeTrigger = (i) => {
		let { actions } = this.state;
		actions.splice(i, 1);
		this.setState({ actions }, () => {
			const newData = { actions: this.state.actions };

		this.props.handleSave(this.props.id, newData);
		});
	};
	handleChange = ({ target }) => {
		let { [target.id]: arr } = this.state;
		arr[target.name] = target.value;
		this.setState({ [target.id]: arr }, () => {
			if (target.value.length) {
				this.toggleButton('remove');
			} else {
				this.toggleButton('add');
			}
		});
	};

	handleBlur = (e) => {
		if (!e.target.value) return
		const newData = { actions: this.state.actions };

		this.props.handleSave(this.props.id, newData);
	}

	render() {
		return (
			<QuestionBuilderComponent
				handleBlur={this.handleBlur}
				handleChange={this.handleChange}
				addTrigger={this.addTrigger}
				removeTrigger={this.removeTrigger}
				{...this.props}
				{...this.state}
			/>
		);
	};
};

export default QuestionBuilder;



// WEBPACK FOOTER //
// ./src/redux/components/organisms/QuestionBuilder/index.js